import React from "react";
import useDeviceType from "Utils/useDeviceType";
import style from "./index.module.scss";
import { activityItem, handleDetailPath } from "../../../../../API/scoreRule";
import { useHistory } from "react-router-dom";

export default function PanelText({
    data,
    courseNo,
    courseSeq,
    weekTimeId
}: {
    data: activityItem;
    courseNo: string;
    courseSeq: string;
    weekTimeId: string;
}) {
    const history = useHistory();
    const { isPC } = useDeviceType();

    const gotoDetail = () => {
        const path = handleDetailPath(courseNo, courseSeq, weekTimeId, data);
        if (!path) return;
        history.push(path);
    };

    if (isPC) {
        return (
            <p className={style.panelText} onClick={gotoDetail}>
                <span />
                <span>{data.name}</span>
                <span>{data.stuStatus}</span>
            </p>
        );
    }
    return (
        <div className={style.panelTextM} onClick={gotoDetail}>
            <p>
                <span />
                <span>{data.name}</span>
            </p>
            <p>
                <span>{data.stuStatus}</span>
            </p>
        </div>
    );
}
